module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8004.e0c3d9ef.png";